import { render, staticRenderFns } from "./RegistrationToStandard.vue?vue&type=template&id=5e1e3f1a&"
import script from "./RegistrationToStandard.vue?vue&type=script&lang=js&"
export * from "./RegistrationToStandard.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationToStandard.vue?vue&type=style&index=0&id=5e1e3f1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports